console.log("PREMIUM NARU Configurator loading...");

// Hintamuutokset
const PRICE_ADJUSTMENTS = {
  euroAdjustment: 0,      // Euromääräinen lisäys/vähennys
  percentAdjustment: 8    // Prosentuaalinen lisäys/vähennys
};

// Määritä konfiguraatio
window.PremiumNaruProductConfig = {
  variantIds: {
    base: 51829082161490,
    adjustment: 51813495931218
  },
  dimensions: {
    minWidth: 300,
    maxWidth: 2200,
    minHeight: 200,
    maxHeight: 2600,
    maxArea: 5.75,
  },
  profiles: {
    white9016: { name: "Valkoinen RAL9016", color: "#FFFFFF" },
    white9016structure: {
      name: "Valkoinen RAL9016 structure",
      color: "#F8F8F8",
    },
    white9010structure: {
      name: "Valkoinen RAL9010 structure",
      color: "#F1F1F1",
    },
    creme9001structure: { name: "Creme RAL9001 structure", color: "#F6F0E7" },
    beige1015: { name: "Beige RAL1015", color: "#EBCC90" },
    bronzeAnodized: { name: "Pronssi anodisoitu", color: "#8E7C67" },
    silverAnodized: { name: "Hopea anodisoitu E6/EV1", color: "#EDEDED" },
    lightGray7040: {
      name: "Vaaleanharmaa RAL7040 structure",
      color: "#C0C0C0",
    },
    darkGrayDB703: { name: "Tummanharmaa DB 703", color: "#575556" },
    anthracite7016: { name: "Antrasiitti RAL7016 structure", color: "#3C3C3C" },
    black9005structure: { name: "Musta RAL9005 structure", color: "#0A0A0A" },
  },

  priceTable: {
    S: {
      700: {
        400: 134,
        500: 141,
        600: 148,
        700: 164,
        800: 176,
        900: 190,
        1000: 201,
        1100: 211,
        1200: 227,
        1300: 238,
        1400: 248,
        1500: 262,
        1600: 272,
        1700: 285,
        1800: 295,
        1900: 307,
        2000: 318,
        2100: 329,
        2200: 345,
      },
      800: {
        400: 136,
        500: 143,
        600: 152,
        700: 167,
        800: 178,
        900: 195,
        1000: 204,
        1100: 215,
        1200: 231,
        1300: 243,
        1400: 253,
        1500: 266,
        1600: 278,
        1700: 291,
        1800: 302,
        1900: 312,
        2000: 325,
        2100: 336,
        2200: 352,
      },
      900: {
        400: 139,
        500: 146,
        600: 155,
        700: 173,
        800: 184,
        900: 200,
        1000: 211,
        1100: 221,
        1200: 238,
        1300: 250,
        1400: 262,
        1500: 276,
        1600: 287,
        1700: 302,
        1800: 312,
        1900: 324,
        2000: 338,
        2100: 348,
        2200: 365,
      },
      1000: {
        400: 142,
        500: 150,
        600: 160,
        700: 177,
        800: 190,
        900: 206,
        1000: 217,
        1100: 228,
        1200: 245,
        1300: 258,
        1400: 269,
        1500: 284,
        1600: 296,
        1700: 311,
        1800: 324,
        1900: 336,
        2000: 349,
        2100: 361,
        2200: 378,
      },
      1100: {
        400: 146,
        500: 154,
        600: 164,
        700: 181,
        800: 194,
        900: 212,
        1000: 223,
        1100: 235,
        1200: 254,
        1300: 265,
        1400: 279,
        1500: 293,
        1600: 306,
        1700: 322,
        1800: 334,
        1900: 347,
        2000: 360,
        2100: 374,
        2200: 390,
      },
      1200: {
        400: 149,
        500: 157,
        600: 168,
        700: 187,
        800: 199,
        900: 216,
        1000: 229,
        1100: 241,
        1200: 261,
        1300: 274,
        1400: 288,
        1500: 302,
        1600: 315,
        1700: 332,
        1800: 345,
        1900: 358,
        2000: 372,
        2100: 385,
        2200: 404,
      },
      1300: {
        400: 153,
        500: 161,
        600: 173,
        700: 191,
        800: 204,
        900: 222,
        1000: 235,
        1100: 250,
        1200: 268,
        1300: 282,
        1400: 295,
        1500: 311,
        1600: 326,
        1700: 342,
        1800: 355,
        1900: 370,
        2000: 384,
        2100: 398,
        2200: 417,
      },
      1400: {
        400: 155,
        500: 164,
        600: 177,
        700: 195,
        800: 210,
        900: 228,
        1000: 241,
        1100: 255,
        1200: 275,
        1300: 290,
        1400: 305,
        1500: 319,
        1600: 334,
        1700: 352,
        1800: 367,
        1900: 381,
        2000: 396,
        2100: 411,
        2200: 430,
      },
      1500: {
        400: 159,
        500: 168,
        600: 180,
        700: 200,
        800: 214,
        900: 234,
        1000: 248,
        1100: 263,
        1200: 283,
        1300: 297,
        1400: 313,
        1500: 329,
        1600: 345,
        1700: 363,
        1800: 377,
        1900: 392,
        2000: 408,
        2100: 424,
        2200: 443,
      },
      1600: {
        400: 162,
        500: 171,
        600: 186,
        700: 208,
        800: 220,
        900: 239,
        1000: 254,
        1100: 270,
        1200: 290,
        1300: 305,
        1400: 321,
        1500: 337,
        1600: 353,
        1700: 373,
        1800: 389,
        1900: 403,
        2000: 421,
        2100: 434,
        2200: 455,
      },
      1700: {
        400: 166,
        500: 175,
        600: 190,
        700: 209,
        800: 226,
        900: 245,
        1000: 261,
        1100: 276,
        1200: 296,
        1300: 313,
        1400: 329,
        1500: 346,
        1600: 364,
        1700: 383,
        1800: 399,
        1900: 414,
        2000: 431,
        2100: 447,
        2200: 468,
      },
      1800: {
        400: 169,
        500: 178,
        600: 193,
        700: 214,
        800: 231,
        900: 250,
        1000: 267,
        1100: 283,
        1200: 304,
        1300: 322,
        1400: 339,
        1500: 356,
        1600: 372,
        1700: 394,
        1800: 409,
        1900: 426,
        2000: 443,
        2100: 460,
        2200: 482,
      },
      1900: {
        400: 172,
        500: 182,
        600: 197,
        700: 220,
        800: 238,
        900: 255,
        1000: 271,
        1100: 290,
        1200: 312,
        1300: 329,
        1400: 346,
        1500: 364,
        1600: 383,
        1700: 403,
        1800: 420,
        1900: 438,
        2000: 455,
        2100: 472,
        2200: 495,
      },
      2000: {
        400: 175,
        500: 185,
        600: 203,
        700: 223,
        800: 242,
        900: 262,
        1000: 278,
        1100: 297,
        1200: 320,
        1300: 337,
        1400: 355,
        1500: 374,
        1600: 392,
        1700: 414,
        1800: 431,
        1900: 449,
        2000: 468,
        2100: 484,
        2200: 508,
      },
      2100: {
        400: 179,
        500: 189,
        600: 206,
        700: 228,
        800: 248,
        900: 267,
        1000: 284,
        1100: 303,
        1200: 326,
        1300: 344,
        1400: 362,
        1500: 382,
        1600: 400,
        1700: 423,
        1800: 442,
        1900: 460,
        2000: 478,
        2100: 497,
        2200: 520,
      },
      2200: {
        400: 182,
        500: 192,
        600: 211,
        700: 233,
        800: 251,
        900: 274,
        1000: 290,
        1100: 309,
        1200: 334,
        1300: 353,
        1400: 372,
        1500: 393,
        1600: 411,
        1700: 434,
        1800: 452,
        1900: 472,
        2000: 490,
        2100: 510,
        2200: 533,
      },
      2300: {
        400: 186,
        500: 197,
        600: 214,
        700: 239,
        800: 257,
        900: 279,
        1000: 297,
        1100: 317,
        1200: 341,
        1300: 361,
        1400: 380,
        1500: 401,
        1600: 419,
        1700: 445,
        1800: 464,
        1900: 484,
        2000: 502,
        2100: 522,
        2200: 546,
      },
      2400: {
        400: 188,
        500: 200,
        600: 219,
        700: 242,
        800: 263,
        900: 283,
        1000: 303,
        1100: 323,
        1200: 349,
        1300: 369,
        1400: 388,
        1500: 410,
        1600: 430,
        1700: 454,
        1800: 473,
        1900: 494,
        2000: 514,
        2100: 535,
        2200: 560,
      },
      2500: {
        400: 192,
        500: 203,
        600: 223,
        700: 247,
        800: 268,
        900: 291,
        1000: 310,
        1100: 330,
        1200: 355,
        1300: 376,
        1400: 397,
        1500: 418,
        1600: 438,
        1700: 465,
        1800: 485,
        1900: 506,
        2000: 526,
        2100: 546,
        2200: 573,
      },
      2600: {
        400: 195,
        500: 207,
        600: 227,
        700: 253,
        800: 273,
        900: 295,
        1000: 315,
        1100: 337,
        1200: 363,
        1300: 384,
        1400: 406,
        1500: 428,
        1600: 449,
        1700: 475,
        1800: 496,
        1900: 517,
        2000: 537,
        2100: 558,
        2200: 585,
      },
      2700: {
        400: 199,
        500: 210,
        600: 232,
        700: 256,
        800: 278,
        900: 301,
        1000: 321,
        1100: 344,
        1200: 371,
        1300: 392,
        1400: 413,
        1500: 437,
        1600: 458,
        1700: 485,
        1800: 506,
        1900: 527,
        2000: 550,
        2100: 571,
        2200: 598,
      },
      2800: {
        400: 202,
        500: 215,
        600: 236,
        700: 261,
        800: 283,
        900: 307,
        1000: 328,
        1100: 350,
        1200: 379,
        1300: 401,
        1400: 423,
        1500: 446,
        1600: 467,
        1700: 495,
        1800: 517,
        1900: 539,
        2000: 561,
        2100: 584,
        2200: 611,
      },
    },
    0: {
      700: {
        400: 142,
        500: 150,
        600: 159,
        700: 176,
        800: 186,
        900: 204,
        1000: 215,
        1100: 226,
        1200: 243,
        1300: 256,
        1400: 266,
        1500: 280,
        1600: 292,
        1700: 306,
        1800: 318,
        1900: 329,
        2000: 343,
        2100: 354,
        2200: 371,
      },
      800: {
        400: 146,
        500: 152,
        600: 161,
        700: 178,
        800: 191,
        900: 209,
        1000: 218,
        1100: 231,
        1200: 249,
        1300: 260,
        1400: 273,
        1500: 286,
        1600: 299,
        1700: 314,
        1800: 325,
        1900: 337,
        2000: 350,
        2100: 362,
        2200: 379,
      },
      900: {
        400: 146,
        500: 156,
        600: 165,
        700: 183,
        800: 197,
        900: 214,
        1000: 225,
        1100: 238,
        1200: 256,
        1300: 270,
        1400: 281,
        1500: 297,
        1600: 308,
        1700: 324,
        1800: 337,
        1900: 349,
        2000: 363,
        2100: 376,
        2200: 395,
      },
      1000: {
        400: 152,
        500: 159,
        600: 171,
        700: 189,
        800: 201,
        900: 220,
        1000: 232,
        1100: 246,
        1200: 266,
        1300: 278,
        1400: 290,
        1500: 305,
        1600: 319,
        1700: 335,
        1800: 350,
        1900: 362,
        2000: 377,
        2100: 389,
        2200: 409,
      },
      1100: {
        400: 155,
        500: 164,
        600: 175,
        700: 194,
        800: 209,
        900: 227,
        1000: 239,
        1100: 253,
        1200: 273,
        1300: 286,
        1400: 300,
        1500: 316,
        1600: 330,
        1700: 347,
        1800: 360,
        1900: 374,
        2000: 390,
        2100: 402,
        2200: 422,
      },
      1200: {
        400: 159,
        500: 168,
        600: 179,
        700: 200,
        800: 213,
        900: 233,
        1000: 247,
        1100: 260,
        1200: 280,
        1300: 294,
        1400: 309,
        1500: 326,
        1600: 340,
        1700: 358,
        1800: 372,
        1900: 387,
        2000: 403,
        2100: 417,
        2200: 437,
      },
      1300: {
        400: 164,
        500: 172,
        600: 185,
        700: 206,
        800: 219,
        900: 239,
        1000: 252,
        1100: 268,
        1200: 289,
        1300: 304,
        1400: 320,
        1500: 336,
        1600: 351,
        1700: 369,
        1800: 385,
        1900: 400,
        2000: 415,
        2100: 431,
        2200: 451,
      },
      1400: {
        400: 167,
        500: 176,
        600: 190,
        700: 210,
        800: 226,
        900: 246,
        1000: 261,
        1100: 276,
        1200: 296,
        1300: 312,
        1400: 328,
        1500: 346,
        1600: 362,
        1700: 381,
        1800: 397,
        1900: 412,
        2000: 429,
        2100: 445,
        2200: 466,
      },
      1500: {
        400: 171,
        500: 181,
        600: 194,
        700: 215,
        800: 231,
        900: 252,
        1000: 267,
        1100: 284,
        1200: 306,
        1300: 322,
        1400: 338,
        1500: 356,
        1600: 372,
        1700: 391,
        1800: 409,
        1900: 425,
        2000: 442,
        2100: 458,
        2200: 480,
      },
      1600: {
        400: 174,
        500: 184,
        600: 198,
        700: 221,
        800: 238,
        900: 259,
        1000: 274,
        1100: 291,
        1200: 314,
        1300: 330,
        1400: 347,
        1500: 365,
        1600: 383,
        1700: 403,
        1800: 420,
        1900: 438,
        2000: 455,
        2100: 472,
        2200: 495,
      },
      1700: {
        400: 179,
        500: 188,
        600: 204,
        700: 226,
        800: 243,
        900: 265,
        1000: 281,
        1100: 296,
        1200: 321,
        1300: 339,
        1400: 356,
        1500: 376,
        1600: 393,
        1700: 415,
        1800: 432,
        1900: 451,
        2000: 469,
        2100: 486,
        2200: 509,
      },
      1800: {
        400: 182,
        500: 191,
        600: 208,
        700: 230,
        800: 249,
        900: 271,
        1000: 287,
        1100: 305,
        1200: 330,
        1300: 348,
        1400: 366,
        1500: 385,
        1600: 404,
        1700: 427,
        1800: 444,
        1900: 462,
        2000: 481,
        2100: 499,
        2200: 523,
      },
      1900: {
        400: 185,
        500: 195,
        600: 212,
        700: 236,
        800: 256,
        900: 276,
        1000: 295,
        1100: 313,
        1200: 337,
        1300: 357,
        1400: 375,
        1500: 396,
        1600: 414,
        1700: 437,
        1800: 456,
        1900: 475,
        2000: 494,
        2100: 513,
        2200: 539,
      },
      2000: {
        400: 188,
        500: 200,
        600: 218,
        700: 241,
        800: 260,
        900: 282,
        1000: 301,
        1100: 320,
        1200: 347,
        1300: 366,
        1400: 385,
        1500: 405,
        1600: 425,
        1700: 449,
        1800: 469,
        1900: 488,
        2000: 508,
        2100: 526,
        2200: 552,
      },
      2100: {
        400: 192,
        500: 203,
        600: 223,
        700: 246,
        800: 266,
        900: 288,
        1000: 309,
        1100: 329,
        1200: 354,
        1300: 374,
        1400: 394,
        1500: 415,
        1600: 436,
        1700: 461,
        1800: 481,
        1900: 500,
        2000: 521,
        2100: 540,
        2200: 566,
      },
      2200: {
        400: 197,
        500: 207,
        600: 226,
        700: 253,
        800: 272,
        900: 295,
        1000: 315,
        1100: 336,
        1200: 361,
        1300: 383,
        1400: 404,
        1500: 426,
        1600: 446,
        1700: 472,
        1800: 491,
        1900: 512,
        2000: 534,
        2100: 555,
        2200: 581,
      },
      2300: {
        400: 200,
        500: 211,
        600: 232,
        700: 257,
        800: 278,
        900: 301,
        1000: 321,
        1100: 344,
        1200: 371,
        1300: 391,
        1400: 413,
        1500: 435,
        1600: 457,
        1700: 482,
        1800: 504,
        1900: 525,
        2000: 546,
        2100: 569,
        2200: 595,
      },
      2400: {
        400: 204,
        500: 216,
        600: 237,
        700: 262,
        800: 284,
        900: 308,
        1000: 329,
        1100: 351,
        1200: 379,
        1300: 401,
        1400: 423,
        1500: 446,
        1600: 466,
        1700: 494,
        1800: 516,
        1900: 538,
        2000: 560,
        2100: 582,
        2200: 609,
      },
      2500: {
        400: 207,
        500: 220,
        600: 241,
        700: 268,
        800: 290,
        900: 314,
        1000: 335,
        1100: 358,
        1200: 387,
        1300: 409,
        1400: 431,
        1500: 455,
        1600: 476,
        1700: 505,
        1800: 529,
        1900: 551,
        2000: 573,
        2100: 595,
        2200: 624,
      },
      2600: {
        400: 212,
        500: 223,
        600: 245,
        700: 273,
        800: 296,
        900: 320,
        1000: 343,
        1100: 366,
        1200: 395,
        1300: 418,
        1400: 441,
        1500: 464,
        1600: 489,
        1700: 516,
        1800: 540,
        1900: 564,
        2000: 586,
        2100: 609,
        2200: 639,
      },
      2700: {
        400: 215,
        500: 227,
        600: 251,
        700: 277,
        800: 301,
        900: 327,
        1000: 349,
        1100: 372,
        1200: 402,
        1300: 427,
        1400: 451,
        1500: 475,
        1600: 498,
        1700: 526,
        1800: 551,
        1900: 576,
        2000: 600,
        2100: 623,
        2200: 653,
      },
      2800: {
        400: 218,
        500: 231,
        600: 256,
        700: 282,
        800: 308,
        900: 333,
        1000: 355,
        1100: 381,
        1200: 412,
        1300: 436,
        1400: 460,
        1500: 486,
        1600: 510,
        1700: 540,
        1800: 564,
        1900: 589,
        2000: 613,
        2100: 637,
        2200: 667,
      },
    },
    1: {
      700: {
        400: 147,
        500: 155,
        600: 170,
        700: 183,
        800: 203,
        900: 223,
        1000: 236,
        1100: 251,
        1200: 266,
        1300: 279,
        1400: 293,
        1500: 308,
        1600: 321,
        1700: 336,
        1800: 355,
        1900: 370,
        2000: 383,
        2100: 396,
        2200: 411,
      },
      800: {
        400: 149,
        500: 158,
        600: 173,
        700: 188,
        800: 209,
        900: 228,
        1000: 243,
        1100: 257,
        1200: 271,
        1300: 286,
        1400: 300,
        1500: 315,
        1600: 331,
        1700: 345,
        1800: 366,
        1900: 380,
        2000: 394,
        2100: 408,
        2200: 422,
      },
      900: {
        400: 154,
        500: 164,
        600: 176,
        700: 194,
        800: 216,
        900: 236,
        1000: 251,
        1100: 267,
        1200: 283,
        1300: 298,
        1400: 313,
        1500: 329,
        1600: 345,
        1700: 360,
        1800: 381,
        1900: 396,
        2000: 411,
        2100: 427,
        2200: 443,
      },
      1000: {
        400: 159,
        500: 169,
        600: 185,
        700: 201,
        800: 224,
        900: 246,
        1000: 261,
        1100: 277,
        1200: 293,
        1300: 310,
        1400: 327,
        1500: 343,
        1600: 359,
        1700: 375,
        1800: 398,
        1900: 414,
        2000: 429,
        2100: 446,
        2200: 462,
      },
      1100: {
        400: 165,
        500: 174,
        600: 191,
        700: 208,
        800: 231,
        900: 253,
        1000: 269,
        1100: 287,
        1200: 304,
        1300: 322,
        1400: 340,
        1500: 357,
        1600: 373,
        1700: 390,
        1800: 414,
        1900: 430,
        2000: 447,
        2100: 464,
        2200: 482,
      },
      1200: {
        400: 169,
        500: 178,
        600: 197,
        700: 214,
        800: 239,
        900: 262,
        1000: 278,
        1100: 298,
        1200: 316,
        1300: 335,
        1400: 353,
        1500: 370,
        1600: 387,
        1700: 407,
        1800: 431,
        1900: 447,
        2000: 467,
        2100: 483,
        2200: 502,
      },
      1300: {
        400: 174,
        500: 184,
        600: 204,
        700: 222,
        800: 247,
        900: 269,
        1000: 287,
        1100: 307,
        1200: 327,
        1300: 345,
        1400: 365,
        1500: 383,
        1600: 403,
        1700: 422,
        1800: 446,
        1900: 465,
        2000: 484,
        2100: 503,
        2200: 522,
      },
      1400: {
        400: 180,
        500: 190,
        600: 208,
        700: 228,
        800: 256,
        900: 279,
        1000: 297,
        1100: 318,
        1200: 339,
        1300: 357,
        1400: 378,
        1500: 397,
        1600: 417,
        1700: 437,
        1800: 463,
        1900: 482,
        2000: 502,
        2100: 522,
        2200: 542,
      },
      1500: {
        400: 185,
        500: 195,
        600: 214,
        700: 236,
        800: 263,
        900: 287,
        1000: 306,
        1100: 329,
        1200: 349,
        1300: 370,
        1400: 392,
        1500: 411,
        1600: 431,
        1700: 453,
        1800: 479,
        1900: 499,
        2000: 520,
        2100: 539,
        2200: 561,
      },
      1600: {
        400: 189,
        500: 201,
        600: 221,
        700: 242,
        800: 271,
        900: 295,
        1000: 315,
        1100: 338,
        1200: 360,
        1300: 382,
        1400: 405,
        1500: 426,
        1600: 446,
        1700: 468,
        1800: 496,
        1900: 517,
        2000: 537,
        2100: 558,
        2200: 581,
      },
      1700: {
        400: 194,
        500: 205,
        600: 227,
        700: 248,
        800: 278,
        900: 304,
        1000: 324,
        1100: 349,
        1200: 372,
        1300: 394,
        1400: 418,
        1500: 439,
        1600: 460,
        1700: 483,
        1800: 512,
        1900: 533,
        2000: 555,
        2100: 577,
        2200: 600,
      },
      1800: {
        400: 199,
        500: 210,
        600: 234,
        700: 256,
        800: 285,
        900: 312,
        1000: 333,
        1100: 358,
        1200: 384,
        1300: 405,
        1400: 430,
        1500: 453,
        1600: 475,
        1700: 500,
        1800: 528,
        1900: 550,
        2000: 574,
        2100: 596,
        2200: 621,
      },
      1900: {
        400: 204,
        500: 217,
        600: 239,
        700: 262,
        800: 295,
        900: 320,
        1000: 343,
        1100: 369,
        1200: 395,
        1300: 417,
        1400: 443,
        1500: 466,
        1600: 490,
        1700: 515,
        1800: 544,
        1900: 567,
        2000: 592,
        2100: 616,
        2200: 640,
      },
      2000: {
        400: 208,
        500: 222,
        600: 245,
        700: 270,
        800: 303,
        900: 328,
        1000: 352,
        1100: 379,
        1200: 405,
        1300: 429,
        1400: 456,
        1500: 480,
        1600: 503,
        1700: 531,
        1800: 561,
        1900: 584,
        2000: 609,
        2100: 634,
        2200: 660,
      },
      2100: {
        400: 214,
        500: 227,
        600: 252,
        700: 276,
        800: 310,
        900: 337,
        1000: 361,
        1100: 389,
        1200: 417,
        1300: 441,
        1400: 470,
        1500: 494,
        1600: 517,
        1700: 545,
        1800: 577,
        1900: 601,
        2000: 627,
        2100: 652,
        2200: 680,
      },
      2200: {
        400: 219,
        500: 233,
        600: 258,
        700: 282,
        800: 317,
        900: 346,
        1000: 369,
        1100: 398,
        1200: 428,
        1300: 453,
        1400: 483,
        1500: 507,
        1600: 532,
        1700: 561,
        1800: 593,
        1900: 618,
        2000: 646,
        2100: 671,
        2200: 700,
      },
      2300: {
        400: 224,
        500: 237,
        600: 265,
        700: 290,
        800: 325,
        900: 353,
        1000: 379,
        1100: 409,
        1200: 439,
        1300: 466,
        1400: 494,
        1500: 521,
        1600: 546,
        1700: 577,
        1800: 609,
        1900: 635,
        2000: 664,
        2100: 690,
        2200: 720,
      },
      2400: {
        400: 230,
        500: 243,
        600: 270,
        700: 295,
        800: 334,
        900: 363,
        1000: 389,
        1100: 418,
        1200: 450,
        1300: 476,
        1400: 507,
        1500: 535,
        1600: 562,
        1700: 593,
        1800: 626,
        1900: 652,
        2000: 683,
        2100: 708,
        2200: 739,
      },
      2500: {
        400: 234,
        500: 249,
        600: 276,
        700: 303,
        800: 342,
        900: 371,
        1000: 398,
        1100: 429,
        1200: 461,
        1300: 489,
        1400: 520,
        1500: 548,
        1600: 576,
        1700: 608,
        1800: 642,
        1900: 669,
        2000: 700,
        2100: 727,
        2200: 759,
      },
      2600: {
        400: 239,
        500: 254,
        600: 283,
        700: 311,
        800: 349,
        900: 379,
        1000: 407,
        1100: 438,
        1200: 472,
        1300: 501,
        1400: 533,
        1500: 561,
        1600: 590,
        1700: 624,
        1800: 657,
        1900: 685,
        2000: 718,
        2100: 747,
        2200: 778,
      },
      2700: {
        400: 244,
        500: 259,
        600: 289,
        700: 318,
        800: 357,
        900: 388,
        1000: 415,
        1100: 449,
        1200: 484,
        1300: 513,
        1400: 545,
        1500: 575,
        1600: 605,
        1700: 639,
        1800: 674,
        1900: 703,
        2000: 736,
        2100: 765,
        2200: 799,
      },
      2800: {
        400: 248,
        500: 264,
        600: 295,
        700: 325,
        800: 364,
        900: 396,
        1000: 425,
        1100: 460,
        1200: 496,
        1300: 525,
        1400: 559,
        1500: 589,
        1600: 620,
        1700: 654,
        1800: 690,
        1900: 719,
        2000: 753,
        2100: 783,
        2200: 819,
      },
    },
    2: {
      700: {
        400: 156,
        500: 167,
        600: 179,
        700: 200,
        800: 219,
        900: 239,
        1000: 257,
        1100: 272,
        1200: 291,
        1300: 306,
        1400: 326,
        1500: 341,
        1600: 360,
        1700: 374,
        1800: 393,
        1900: 408,
        2000: 427,
        2100: 441,
        2200: 461,
      },
      800: {
        400: 161,
        500: 170,
        600: 185,
        700: 205,
        800: 225,
        900: 246,
        1000: 265,
        1100: 280,
        1200: 301,
        1300: 315,
        1400: 335,
        1500: 350,
        1600: 371,
        1700: 386,
        1800: 406,
        1900: 421,
        2000: 441,
        2100: 456,
        2200: 476,
      },
      900: {
        400: 167,
        500: 176,
        600: 192,
        700: 214,
        800: 234,
        900: 258,
        1000: 276,
        1100: 293,
        1200: 315,
        1300: 330,
        1400: 353,
        1500: 368,
        1600: 391,
        1700: 406,
        1800: 426,
        1900: 443,
        2000: 463,
        2100: 479,
        2200: 502,
      },
      1000: {
        400: 173,
        500: 183,
        600: 201,
        700: 223,
        800: 245,
        900: 268,
        1000: 289,
        1100: 306,
        1200: 330,
        1300: 346,
        1400: 369,
        1500: 385,
        1600: 410,
        1700: 427,
        1800: 449,
        1900: 466,
        2000: 488,
        2100: 505,
        2200: 529,
      },
      1100: {
        400: 180,
        500: 190,
        600: 208,
        700: 231,
        800: 256,
        900: 280,
        1000: 302,
        1100: 319,
        1200: 343,
        1300: 362,
        1400: 386,
        1500: 404,
        1600: 429,
        1700: 447,
        1800: 470,
        1900: 488,
        2000: 510,
        2100: 529,
        2200: 555,
      },
      1200: {
        400: 186,
        500: 197,
        600: 217,
        700: 241,
        800: 265,
        900: 291,
        1000: 314,
        1100: 333,
        1200: 358,
        1300: 378,
        1400: 402,
        1500: 423,
        1600: 447,
        1700: 467,
        1800: 491,
        1900: 511,
        2000: 535,
        2100: 555,
        2200: 581,
      },
      1300: {
        400: 192,
        500: 204,
        600: 225,
        700: 252,
        800: 276,
        900: 301,
        1000: 327,
        1100: 346,
        1200: 373,
        1300: 394,
        1400: 420,
        1500: 441,
        1600: 466,
        1700: 487,
        1800: 514,
        1900: 534,
        2000: 557,
        2100: 579,
        2200: 608,
      },
      1400: {
        400: 199,
        500: 210,
        600: 233,
        700: 260,
        800: 285,
        900: 313,
        1000: 337,
        1100: 356,
        1200: 387,
        1300: 409,
        1400: 437,
        1500: 459,
        1600: 485,
        1700: 508,
        1800: 534,
        1900: 555,
        2000: 582,
        2100: 604,
        2200: 635,
      },
      1500: {
        400: 205,
        500: 217,
        600: 241,
        700: 269,
        800: 296,
        900: 325,
        1000: 350,
        1100: 372,
        1200: 401,
        1300: 425,
        1400: 453,
        1500: 476,
        1600: 505,
        1700: 528,
        1800: 555,
        1900: 579,
        2000: 606,
        2100: 629,
        2200: 661,
      },
      1600: {
        400: 212,
        500: 224,
        600: 250,
        700: 277,
        800: 305,
        900: 334,
        1000: 363,
        1100: 385,
        1200: 417,
        1300: 441,
        1400: 470,
        1500: 494,
        1600: 523,
        1700: 548,
        1800: 577,
        1900: 601,
        2000: 629,
        2100: 654,
        2200: 690,
      },
      1700: {
        400: 218,
        500: 231,
        600: 257,
        700: 287,
        800: 316,
        900: 346,
        1000: 375,
        1100: 399,
        1200: 431,
        1300: 456,
        1400: 486,
        1500: 512,
        1600: 542,
        1700: 568,
        1800: 596,
        1900: 624,
        2000: 653,
        2100: 678,
        2200: 714,
      },
      1800: {
        400: 224,
        500: 238,
        600: 266,
        700: 295,
        800: 326,
        900: 358,
        1000: 387,
        1100: 412,
        1200: 446,
        1300: 473,
        1400: 504,
        1500: 531,
        1600: 561,
        1700: 590,
        1800: 619,
        1900: 646,
        2000: 675,
        2100: 703,
        2200: 742,
      },
      1900: {
        400: 231,
        500: 246,
        600: 273,
        700: 308,
        800: 337,
        900: 368,
        1000: 399,
        1100: 425,
        1200: 460,
        1300: 488,
        1400: 520,
        1500: 548,
        1600: 580,
        1700: 610,
        1800: 641,
        1900: 669,
        2000: 700,
        2100: 726,
        2200: 769,
      },
      2000: {
        400: 237,
        500: 251,
        600: 282,
        700: 314,
        800: 347,
        900: 379,
        1000: 412,
        1100: 438,
        1200: 473,
        1300: 504,
        1400: 537,
        1500: 567,
        1600: 598,
        1700: 629,
        1800: 662,
        1900: 692,
        2000: 723,
        2100: 753,
        2200: 795,
      },
      2100: {
        400: 244,
        500: 259,
        600: 290,
        700: 323,
        800: 357,
        900: 391,
        1000: 424,
        1100: 451,
        1200: 488,
        1300: 520,
        1400: 553,
        1500: 585,
        1600: 618,
        1700: 649,
        1800: 683,
        1900: 715,
        2000: 747,
        2100: 779,
        2200: 822,
      },
      2200: {
        400: 250,
        500: 266,
        600: 298,
        700: 333,
        800: 368,
        900: 401,
        1000: 435,
        1100: 464,
        1200: 503,
        1300: 535,
        1400: 570,
        1500: 602,
        1600: 637,
        1700: 670,
        1800: 703,
        1900: 737,
        2000: 770,
        2100: 803,
        2200: 849,
      },
      2300: {
        400: 256,
        500: 271,
        600: 306,
        700: 341,
        800: 377,
        900: 413,
        1000: 448,
        1100: 478,
        1200: 517,
        1300: 552,
        1400: 586,
        1500: 621,
        1600: 656,
        1700: 690,
        1800: 726,
        1900: 760,
        2000: 795,
        2100: 828,
        2200: 875,
      },
      2400: {
        400: 263,
        500: 280,
        600: 315,
        700: 352,
        800: 388,
        900: 425,
        1000: 460,
        1100: 491,
        1200: 532,
        1300: 567,
        1400: 604,
        1500: 639,
        1600: 675,
        1700: 710,
        1800: 747,
        1900: 782,
        2000: 818,
        2100: 853,
        2200: 902,
      },
      2500: {
        400: 268,
        500: 286,
        600: 322,
        700: 360,
        800: 397,
        900: 436,
        1000: 473,
        1100: 506,
        1200: 546,
        1300: 582,
        1400: 621,
        1500: 657,
        1600: 694,
        1700: 730,
        1800: 768,
        1900: 806,
        2000: 842,
        2100: 878,
        2200: 929,
      },
      2600: {
        400: 276,
        500: 294,
        600: 331,
        700: 370,
        800: 408,
        900: 446,
        1000: 484,
        1100: 517,
        1200: 562,
        1300: 599,
        1400: 637,
        1500: 674,
        1600: 713,
        1700: 751,
        1800: 790,
        1900: 828,
        2000: 865,
        2100: 903,
        2200: 955,
      },
      2700: {
        400: 281,
        500: 300,
        600: 338,
        700: 378,
        800: 419,
        900: 458,
        1000: 497,
        1100: 530,
        1200: 576,
        1300: 614,
        1400: 654,
        1500: 692,
        1600: 733,
        1700: 771,
        1800: 811,
        1900: 849,
        2000: 889,
        2100: 927,
        2200: 982,
      },
      2800: {
        400: 287,
        500: 306,
        600: 348,
        700: 387,
        800: 428,
        900: 470,
        1000: 508,
        1100: 544,
        1200: 590,
        1300: 631,
        1400: 670,
        1500: 710,
        1600: 752,
        1700: 791,
        1800: 832,
        1900: 873,
        2000: 913,
        2100: 952,
        2200: 1009,
      },
    },
    3: {
      700: {
        400: 167,
        500: 176,
        600: 195,
        700: 215,
        800: 230,
        900: 261,
        1000: 272,
        1100: 293,
        1200: 314,
        1300: 333,
        1400: 353,
        1500: 372,
        1600: 393,
        1700: 413,
        1800: 432,
        1900: 445,
        2000: 463,
        2100: 484,
        2200: 509,
      },
      800: {
        400: 171,
        500: 182,
        600: 203,
        700: 222,
        800: 238,
        900: 269,
        1000: 283,
        1100: 305,
        1200: 323,
        1300: 344,
        1400: 365,
        1500: 385,
        1600: 405,
        1700: 427,
        1800: 448,
        1900: 461,
        2000: 481,
        2100: 503,
        2200: 526,
      },
      900: {
        400: 179,
        500: 189,
        600: 211,
        700: 233,
        800: 250,
        900: 282,
        1000: 296,
        1100: 319,
        1200: 342,
        1300: 363,
        1400: 386,
        1500: 408,
        1600: 430,
        1700: 452,
        1800: 473,
        1900: 489,
        2000: 510,
        2100: 532,
        2200: 560,
      },
      1000: {
        400: 186,
        500: 198,
        600: 221,
        700: 244,
        800: 263,
        900: 296,
        1000: 314,
        1100: 335,
        1200: 360,
        1300: 384,
        1400: 407,
        1500: 430,
        1600: 452,
        1700: 478,
        1800: 501,
        1900: 518,
        2000: 540,
        2100: 563,
        2200: 593,
      },
      1100: {
        400: 194,
        500: 205,
        600: 230,
        700: 256,
        800: 276,
        900: 309,
        1000: 329,
        1100: 352,
        1200: 379,
        1300: 403,
        1400: 427,
        1500: 453,
        1600: 477,
        1700: 501,
        1800: 528,
        1900: 546,
        2000: 570,
        2100: 595,
        2200: 625,
      },
      1200: {
        400: 201,
        500: 214,
        600: 240,
        700: 268,
        800: 288,
        900: 324,
        1000: 344,
        1100: 369,
        1200: 398,
        1300: 422,
        1400: 447,
        1500: 475,
        1600: 500,
        1700: 527,
        1800: 554,
        1900: 574,
        2000: 600,
        2100: 625,
        2200: 657,
      },
      1300: {
        400: 208,
        500: 222,
        600: 251,
        700: 277,
        800: 299,
        900: 335,
        1000: 360,
        1100: 385,
        1200: 416,
        1300: 442,
        1400: 470,
        1500: 495,
        1600: 524,
        1700: 552,
        1800: 581,
        1900: 603,
        2000: 629,
        2100: 656,
        2200: 690,
      },
      1400: {
        400: 215,
        500: 230,
        600: 259,
        700: 289,
        800: 312,
        900: 350,
        1000: 375,
        1100: 402,
        1200: 433,
        1300: 461,
        1400: 490,
        1500: 520,
        1600: 548,
        1700: 578,
        1800: 608,
        1900: 631,
        2000: 659,
        2100: 688,
        2200: 722,
      },
      1500: {
        400: 222,
        500: 238,
        600: 270,
        700: 301,
        800: 325,
        900: 364,
        1000: 389,
        1100: 418,
        1200: 452,
        1300: 482,
        1400: 510,
        1500: 541,
        1600: 571,
        1700: 601,
        1800: 633,
        1900: 659,
        2000: 688,
        2100: 719,
        2200: 753,
      },
      1600: {
        400: 231,
        500: 247,
        600: 278,
        700: 312,
        800: 338,
        900: 377,
        1000: 403,
        1100: 435,
        1200: 470,
        1300: 501,
        1400: 532,
        1500: 564,
        1600: 595,
        1700: 627,
        1800: 660,
        1900: 686,
        2000: 719,
        2100: 748,
        2200: 786,
      },
      1700: {
        400: 238,
        500: 254,
        600: 289,
        700: 322,
        800: 350,
        900: 391,
        1000: 419,
        1100: 451,
        1200: 488,
        1300: 520,
        1400: 552,
        1500: 587,
        1600: 618,
        1700: 653,
        1800: 686,
        1900: 715,
        2000: 749,
        2100: 781,
        2200: 818,
      },
      1800: {
        400: 246,
        500: 263,
        600: 298,
        700: 334,
        800: 363,
        900: 404,
        1000: 434,
        1100: 468,
        1200: 506,
        1300: 540,
        1400: 572,
        1500: 608,
        1600: 642,
        1700: 678,
        1800: 713,
        1900: 743,
        2000: 778,
        2100: 812,
        2200: 850,
      },
      1900: {
        400: 253,
        500: 270,
        600: 308,
        700: 345,
        800: 375,
        900: 417,
        1000: 449,
        1100: 484,
        1200: 525,
        1300: 559,
        1400: 594,
        1500: 632,
        1600: 664,
        1700: 703,
        1800: 740,
        1900: 771,
        2000: 809,
        2100: 841,
        2200: 883,
      },
      2000: {
        400: 261,
        500: 279,
        600: 318,
        700: 357,
        800: 389,
        900: 430,
        1000: 465,
        1100: 501,
        1200: 544,
        1300: 579,
        1400: 615,
        1500: 653,
        1600: 689,
        1700: 728,
        1800: 766,
        1900: 800,
        2000: 837,
        2100: 873,
        2200: 915,
      },
      2100: {
        400: 268,
        500: 287,
        600: 326,
        700: 368,
        800: 402,
        900: 444,
        1000: 480,
        1100: 517,
        1200: 562,
        1300: 599,
        1400: 635,
        1500: 676,
        1600: 713,
        1700: 754,
        1800: 793,
        1900: 828,
        2000: 867,
        2100: 904,
        2200: 947,
      },
      2200: {
        400: 277,
        500: 295,
        600: 337,
        700: 378,
        800: 414,
        900: 458,
        1000: 495,
        1100: 534,
        1200: 579,
        1300: 618,
        1400: 656,
        1500: 698,
        1600: 736,
        1700: 778,
        1800: 820,
        1900: 856,
        2000: 897,
        2100: 934,
        2200: 980,
      },
      2300: {
        400: 284,
        500: 303,
        600: 346,
        700: 390,
        800: 427,
        900: 471,
        1000: 511,
        1100: 550,
        1200: 598,
        1300: 637,
        1400: 677,
        1500: 720,
        1600: 760,
        1700: 803,
        1800: 846,
        1900: 883,
        2000: 927,
        2100: 965,
        2200: 1012,
      },
      2400: {
        400: 292,
        500: 312,
        600: 356,
        700: 401,
        800: 440,
        900: 485,
        1000: 526,
        1100: 567,
        1200: 615,
        1300: 658,
        1400: 699,
        1500: 742,
        1600: 784,
        1700: 828,
        1800: 873,
        1900: 912,
        2000: 956,
        2100: 997,
        2200: 1044,
      },
      2500: {
        400: 298,
        500: 319,
        600: 367,
        700: 412,
        800: 453,
        900: 497,
        1000: 541,
        1100: 583,
        1200: 634,
        1300: 677,
        1400: 719,
        1500: 765,
        1600: 807,
        1700: 854,
        1800: 900,
        1900: 941,
        2000: 987,
        2100: 1028,
        2200: 1077,
      },
      2600: {
        400: 305,
        500: 328,
        600: 375,
        700: 423,
        800: 465,
        900: 511,
        1000: 557,
        1100: 600,
        1200: 652,
        1300: 697,
        1400: 739,
        1500: 788,
        1600: 831,
        1700: 879,
        1800: 926,
        1900: 970,
        2000: 1015,
        2100: 1059,
        2200: 1108,
      },
      2700: {
        400: 313,
        500: 335,
        600: 385,
        700: 434,
        800: 477,
        900: 524,
        1000: 572,
        1100: 616,
        1200: 671,
        1300: 716,
        1400: 761,
        1500: 810,
        1600: 854,
        1700: 903,
        1800: 954,
        1900: 997,
        2000: 1045,
        2100: 1090,
        2200: 1140,
      },
      2800: {
        400: 320,
        500: 345,
        600: 395,
        700: 446,
        800: 490,
        900: 538,
        1000: 587,
        1100: 633,
        1200: 689,
        1300: 734,
        1400: 781,
        1500: 832,
        1600: 878,
        1700: 929,
        1800: 979,
        1900: 1025,
        2000: 1075,
        2100: 1121,
        2200: 1173,
      },
    },
    4: {
      700: {
        400: 184,
        500: 194,
        600: 216,
        700: 238,
        800: 254,
        900: 290,
        1000: 304,
        1100: 326,
        1200: 349,
        1300: 371,
        1400: 393,
        1500: 415,
        1600: 439,
        1700: 461,
        1800: 483,
        1900: 496,
        2000: 517,
        2100: 541,
        2200: 570,
      },
      800: {
        400: 188,
        500: 200,
        600: 224,
        700: 245,
        800: 264,
        900: 299,
        1000: 315,
        1100: 337,
        1200: 360,
        1300: 383,
        1400: 407,
        1500: 430,
        1600: 452,
        1700: 477,
        1800: 500,
        1900: 515,
        2000: 538,
        2100: 562,
        2200: 591,
      },
      900: {
        400: 197,
        500: 209,
        600: 233,
        700: 258,
        800: 277,
        900: 314,
        1000: 332,
        1100: 356,
        1200: 382,
        1300: 405,
        1400: 431,
        1500: 456,
        1600: 481,
        1700: 505,
        1800: 530,
        1900: 548,
        2000: 572,
        2100: 596,
        2200: 628,
      },
      1000: {
        400: 206,
        500: 219,
        600: 245,
        700: 272,
        800: 292,
        900: 330,
        1000: 350,
        1100: 375,
        1200: 402,
        1300: 430,
        1400: 456,
        1500: 482,
        1600: 506,
        1700: 535,
        1800: 561,
        1900: 581,
        2000: 606,
        2100: 632,
        2200: 666,
      },
      1100: {
        400: 215,
        500: 228,
        600: 255,
        700: 285,
        800: 307,
        900: 345,
        1000: 368,
        1100: 394,
        1200: 424,
        1300: 451,
        1400: 479,
        1500: 508,
        1600: 535,
        1700: 562,
        1800: 592,
        1900: 613,
        2000: 641,
        2100: 668,
        2200: 702,
      },
      1200: {
        400: 223,
        500: 237,
        600: 267,
        700: 299,
        800: 321,
        900: 362,
        1000: 385,
        1100: 413,
        1200: 446,
        1300: 473,
        1400: 502,
        1500: 533,
        1600: 562,
        1700: 592,
        1800: 622,
        1900: 646,
        2000: 675,
        2100: 704,
        2200: 739,
      },
      1300: {
        400: 201,
        500: 247,
        600: 279,
        700: 310,
        800: 334,
        900: 375,
        1000: 403,
        1100: 432,
        1200: 466,
        1300: 496,
        1400: 528,
        1500: 558,
        1600: 589,
        1700: 621,
        1800: 654,
        1900: 678,
        2000: 709,
        2100: 739,
        2200: 777,
      },
      1400: {
        400: 239,
        500: 256,
        600: 289,
        700: 323,
        800: 349,
        900: 394,
        1000: 421,
        1100: 451,
        1200: 486,
        1300: 518,
        1400: 551,
        1500: 585,
        1600: 616,
        1700: 651,
        1800: 685,
        1900: 711,
        2000: 743,
        2100: 775,
        2200: 814,
      },
      1500: {
        400: 248,
        500: 266,
        600: 301,
        700: 337,
        800: 364,
        900: 408,
        1000: 437,
        1100: 470,
        1200: 508,
        1300: 542,
        1400: 574,
        1500: 609,
        1600: 643,
        1700: 678,
        1800: 713,
        1900: 743,
        2000: 777,
        2100: 811,
        2200: 850,
      },
      1600: {
        400: 257,
        500: 275,
        600: 311,
        700: 349,
        800: 379,
        900: 423,
        1000: 453,
        1100: 489,
        1200: 528,
        1300: 564,
        1400: 599,
        1500: 635,
        1600: 671,
        1700: 707,
        1800: 744,
        1900: 775,
        2000: 812,
        2100: 846,
        2200: 888,
      },
      1700: {
        400: 265,
        500: 283,
        600: 323,
        700: 361,
        800: 393,
        900: 439,
        1000: 471,
        1100: 508,
        1200: 550,
        1300: 586,
        1400: 623,
        1500: 662,
        1600: 698,
        1700: 737,
        1800: 774,
        1900: 807,
        2000: 846,
        2100: 883,
        2200: 925,
      },
      1800: {
        400: 275,
        500: 294,
        600: 334,
        700: 375,
        800: 407,
        900: 454,
        1000: 488,
        1100: 527,
        1200: 570,
        1300: 609,
        1400: 646,
        1500: 687,
        1600: 725,
        1700: 766,
        1800: 805,
        1900: 840,
        2000: 880,
        2100: 918,
        2200: 962,
      },
      1900: {
        400: 283,
        500: 302,
        600: 345,
        700: 387,
        800: 422,
        900: 469,
        1000: 506,
        1100: 546,
        1200: 592,
        1300: 630,
        1400: 670,
        1500: 714,
        1600: 751,
        1700: 794,
        1800: 837,
        1900: 872,
        2000: 915,
        2100: 952,
        2200: 1000,
      },
      2000: {
        400: 292,
        500: 312,
        600: 357,
        700: 400,
        800: 437,
        900: 484,
        1000: 524,
        1100: 565,
        1200: 614,
        1300: 653,
        1400: 694,
        1500: 738,
        1600: 779,
        1700: 823,
        1800: 866,
        1900: 905,
        2000: 947,
        2100: 988,
        2200: 1036,
      },
      2100: {
        400: 301,
        500: 321,
        600: 366,
        700: 414,
        800: 452,
        900: 500,
        1000: 541,
        1100: 584,
        1200: 634,
        1300: 676,
        1400: 717,
        1500: 764,
        1600: 806,
        1700: 853,
        1800: 898,
        1900: 937,
        2000: 981,
        2100: 1024,
        2200: 1076,
      },
      2200: {
        400: 310,
        500: 331,
        600: 378,
        700: 425,
        800: 466,
        900: 516,
        1000: 559,
        1100: 603,
        1200: 655,
        1300: 698,
        1400: 742,
        1500: 790,
        1600: 833,
        1700: 881,
        1800: 929,
        1900: 970,
        2000: 1017,
        2100: 1059,
        2200: 1111,
      },
      2300: {
        400: 318,
        500: 340,
        600: 389,
        700: 438,
        800: 481,
        900: 531,
        1000: 577,
        1100: 622,
        1200: 676,
        1300: 720,
        1400: 766,
        1500: 815,
        1600: 860,
        1700: 910,
        1800: 959,
        1900: 1001,
        2000: 1051,
        2100: 1096,
        2200: 1147,
      },
      2400: {
        400: 328,
        500: 350,
        600: 400,
        700: 452,
        800: 496,
        900: 547,
        1000: 594,
        1100: 641,
        1200: 697,
        1300: 744,
        1400: 791,
        1500: 840,
        1600: 888,
        1700: 938,
        1800: 990,
        1900: 1034,
        2000: 1084,
        2100: 1131,
        2200: 1184,
      },
      2500: {
        400: 334,
        500: 358,
        600: 412,
        700: 464,
        800: 511,
        900: 561,
        1000: 612,
        1100: 660,
        1200: 717,
        1300: 766,
        1400: 814,
        1500: 867,
        1600: 915,
        1700: 968,
        1800: 1021,
        1900: 1068,
        2000: 1120,
        2100: 1166,
        2200: 1222,
      },
      2600: {
        400: 343,
        500: 369,
        600: 422,
        700: 476,
        800: 525,
        900: 577,
        1000: 630,
        1100: 679,
        1200: 739,
        1300: 789,
        1400: 837,
        1500: 893,
        1600: 942,
        1700: 996,
        1800: 1051,
        1900: 1100,
        2000: 1152,
        2100: 1203,
        2200: 1259,
      },
      2700: {
        400: 352,
        500: 377,
        600: 434,
        700: 490,
        800: 539,
        900: 592,
        1000: 647,
        1100: 698,
        1200: 760,
        1300: 811,
        1400: 863,
        1500: 919,
        1600: 969,
        1700: 1025,
        1800: 1082,
        1900: 1131,
        2000: 1186,
        2100: 1238,
        2200: 1295,
      },
      2800: {
        400: 360,
        500: 388,
        600: 445,
        700: 503,
        800: 554,
        900: 609,
        1000: 665,
        1100: 717,
        1200: 781,
        1300: 832,
        1400: 886,
        1500: 944,
        1600: 996,
        1700: 1055,
        1800: 1112,
        1900: 1164,
        2000: 1221,
        2100: 1273,
        2200: 1333,
      },
    },
  },
};

document.addEventListener("DOMContentLoaded", function () {
  const config = window.PremiumNaruProductConfig;
  let selectedFabricGroup = null;
  let selectedProfile = null;
  let widthInput, heightInput, profileStep, priceDisplay, calculatedPrice;

  // Piilota alkuperäinen ostoskoriin-nappi heti
  setTimeout(function () {
    const originalButton = document.querySelector('button[name="add"]');

    if (originalButton) {
      originalButton.style.position = "absolute";
      originalButton.style.left = "-9999px";
      originalButton.style.visibility = "hidden";
      console.log("Original button hidden on page load");
    }
  }, 100);

  // Odota että DOM on valmis, sitten luo elementit
  setTimeout(function () {
    console.log("Calling createPremiumNaruElements...");
    createPremiumNaruElements();

    // Tunnista oletuskangasväri sivun latautuessa
    const fabricSelect = document.querySelector(
      'select[name="options[KANGAS]"]'
    );
    if (fabricSelect && fabricSelect.selectedIndex >= 0) {
      const selectedOption = fabricSelect.options[fabricSelect.selectedIndex];
      const variantTitle = selectedOption.text;
      const groupMatch = variantTitle.match(/\(([^)]+)\)[^(]*$/);
      if (groupMatch) {
        selectedFabricGroup = groupMatch[1];
        console.log("Initial fabric group detected:", selectedFabricGroup);

        if (profileStep) {
          profileStep.classList.remove("disabled");
          profileStep.classList.add("active");
          createProfileOptions();
        }
      }
    }

    // Kangasvärin valinta
    if (fabricSelect) {
      fabricSelect.addEventListener("change", function () {
        const selectedOption = this.options[this.selectedIndex];
        const variantTitle = selectedOption.text;

        const groupMatch = variantTitle.match(/\(([^)]+)\)[^(]*$/);
        if (groupMatch) {
          selectedFabricGroup = groupMatch[1];
          console.log("Selected fabric group:", selectedFabricGroup);

          if (profileStep) {
            profileStep.classList.remove("disabled");
            profileStep.classList.add("active");
            createProfileOptions();
          }
          calculatePrice();
        }
      });
    }
  }, 300);

  function createPremiumNaruElements() {
  const productForm =
    document.querySelector(".product-form") ||
    document.querySelector(".product__info-wrapper") ||
    document.body;

  // Luo pääkontaineri
  let configurator = document.getElementById("premium-naru-configurator");
  if (!configurator) {
    configurator = document.createElement("div");
    configurator.id = "premium-naru-configurator";
    configurator.className = "premium-naru-configurator";
    productForm.appendChild(configurator);
  }

    // Luo mittakentät
    if (!document.getElementById("width-input")) {
      const dimensionsDiv = document.createElement("div");
      dimensionsDiv.className = "config-step active";

      dimensionsDiv.innerHTML = `
            <h3>Syötä mitat (mm)</h3>
            <div class="dimension-inputs">
                <div class="input-group">
                    <label>Leveys</label>
                    <input placeholder="esim. 1400" max="2200" min="300" id="width-input" type="number">
                    <div id="width-validation" class="validation-message"></div>
                </div>
                <div class="input-group">
                    <label>Korkeus</label>
                    <input placeholder="esim. 1800" max="2600" min="200" id="height-input" type="number">
                    <div id="height-validation" class="validation-message"></div>
                </div>
            </div>
        `;

      configurator.appendChild(dimensionsDiv);
    }

    // Luo profiiliväri-osio
    if (!document.getElementById("profile-step")) {
      const profileDiv = document.createElement("div");
      profileDiv.id = "profile-step";
      profileDiv.className = "config-step disabled";
      profileDiv.innerHTML = `
            <h3>Valitse profiiliväri</h3>
            <div id="profile-options"></div>
        `;
      configurator.appendChild(profileDiv);
    }

    // Luo hinta-osio
    if (!document.getElementById("price-display")) {
      const priceDiv = document.createElement("div");
      priceDiv.id = "price-display";
      priceDiv.className = "config-step price-display";
      priceDiv.style.display = "none";
      priceDiv.innerHTML = `
            <h3>Hinta</h3>
            <div style="font-size: 2rem; font-weight: bold; color: #ffffff; margin-bottom: 15px;" id="calculated-price"></div>
        `;
      configurator.appendChild(priceDiv);
    }

    // Päivitä elementtiviittaukset
    widthInput = document.getElementById("width-input");
    heightInput = document.getElementById("height-input");
    profileStep = document.getElementById("profile-step");
    priceDisplay = document.getElementById("price-display");
    calculatedPrice = document.getElementById("calculated-price");
  }

  function getProfilesForProduct() {
    const productHandle = window.location.pathname;

    // Jos ALL-BLACK tai MUSTA tuote - vain musta profiili
    if (
      productHandle.includes("all-black") ||
      productHandle.includes("musta")
    ) {
      return {
        anthracite: {
          name: "Musta RAL9005 structure",
          color: "#0A0A0A",
        },
      };
    }

    // Muuten kaikki normaalit PREMIUM profiilit
    return config.profiles;
  }

  function createProfileOptions() {
    const profileOptions = document.getElementById("profile-options");
    if (!profileOptions) return;

    const customDropdown = document.createElement("div");
    customDropdown.className = "custom-dropdown";

    const selected = document.createElement("div");
    selected.className = "dropdown-selected";

    selected.innerHTML = `
    <span>Valitse profiiliväri</span>
    <span class="dropdown-arrow">▼</span>
`;

      const options = document.createElement("div");
      options.className = "dropdown-options";

    // Lisää profiilivärit
    Object.keys(getProfilesForProduct()).forEach(function (key) {
      const profile = getProfilesForProduct()[key];

      const option = document.createElement("div");
      option.className = "dropdown-option";

      options.style.maxHeight = "400px";
      options.style.overflowY = "auto";
      option.innerHTML = `
    <span class="profile-color-icon" style="background-color: ${profile.color};"></span>
    <span class="profile-option-text">${profile.name}</span>
  `;

      option.addEventListener("click", function () {
        selectedProfile = key;
        selected.innerHTML = `
      <span class="dropdown-selected-content">
        <span class="profile-color-icon" style="background-color: ${profile.color};"></span>
        ${profile.name}
      </span>
      <span class="dropdown-arrow">▼</span>
    `;

        options.classList.remove("show");
        calculatePrice();
      });

      options.appendChild(option);
    });

    selected.addEventListener("click", function () {
      options.classList.toggle("show");
    });

    customDropdown.appendChild(selected);
    customDropdown.appendChild(options);

    profileOptions.innerHTML = "";
    profileOptions.appendChild(customDropdown);
  }

  function calculatePrice() {
    console.log("calculatePrice called");
    const width = parseInt(widthInput?.value) || 0;
    const height = parseInt(heightInput?.value) || 0;

    // Tarkista validointi ensin
    if (!updateFieldValidation()) {
      console.log("Validation failed");
      // Näytä lähtöhinta vaikka validointi epäonnistui (Google-vaatimus)
      if (priceDisplay) priceDisplay.style.display = "block";
      if (calculatedPrice) calculatedPrice.textContent = "Alkaen 165.00 €";
      return;
    }

    // Tarkista että profiiliväri on valittu
    if (!selectedProfile) {
      console.log("No profile selected");
      // Näytä lähtöhinta vaikka profiilia ei valittu (Google-vaatimus)
      if (priceDisplay) priceDisplay.style.display = "block";
      if (calculatedPrice) calculatedPrice.textContent = "Alkaen 165.00 €";
      return;
    }

    console.log("Current values:", {
      width: width,
      height: height,
      selectedFabricGroup: selectedFabricGroup,
      selectedProfile: selectedProfile,
    });

    if (
      width > 0 &&
      height > 0 &&
      selectedFabricGroup &&
      config.priceTable[selectedFabricGroup]
    ) {
      const normalizedWidth = Math.min(
        Math.max(Math.ceil(width / 100) * 100, 400),
        2300
      );
      const normalizedHeight = Math.min(
        Math.max(Math.ceil(height / 100) * 100, 700),
        2700
      );

      console.log(
        "Normalized dimensions:",
        normalizedWidth,
        "x",
        normalizedHeight
      );

      const priceData = config.priceTable[selectedFabricGroup];
      let basePrice = null;

      if (priceData[normalizedHeight]) {
        if (priceData[normalizedHeight][normalizedWidth]) {
          basePrice = priceData[normalizedHeight][normalizedWidth];
          console.log("Price found:", basePrice);
        } else {
          // B-hinnoittelu: etsi lähin pienempi leveys
          for (let w = normalizedWidth - 100; w >= 400; w -= 100) {
            if (priceData[normalizedHeight][w]) {
              basePrice = priceData[normalizedHeight][w];
              console.log("B-pricing: Found price", basePrice, "at width", w);
              break;
            }
          }
          if (!basePrice) basePrice = 165.0;
        }
      } else {
        // B-hinnoittelu: etsi lähin pienempi korkeus
        for (let h = normalizedHeight - 100; h >= 700; h -= 100) {
          if (priceData[h] && priceData[h][normalizedWidth]) {
            basePrice = priceData[h][normalizedWidth];
            console.log("B-pricing: Found price", basePrice, "at height", h);
            break;
          }
        }
        if (!basePrice) basePrice = 165.0;
      }

      if (calculatedPrice && basePrice) {
        // 1. Lisää euromääräinen muutos
        let priceAfterEuro = basePrice + PRICE_ADJUSTMENTS.euroAdjustment;
        console.log("After euro adjustment:", priceAfterEuro);
        
        // 2. Lisää prosentuaalinen muutos
        let priceAfterPercent = priceAfterEuro * (1 + PRICE_ADJUSTMENTS.percentAdjustment / 100);
        console.log("After percent adjustment:", priceAfterPercent);
        
        // 3. Pyöristä lähimpään tasaeuroon
        let roundedPrice = Math.round(priceAfterPercent);
        console.log("After rounding:", roundedPrice);
        
        // 4. Varmista minimihinta 165 €
        const finalPrice = Math.max(roundedPrice, 165);
        console.log("Final price:", finalPrice);
        
        calculatedPrice.textContent = finalPrice.toFixed(2) + " €";
      }
      if (priceDisplay) {
        priceDisplay.style.display = "block";
      }

      // Lisää ostoskoriin-nappi
      createAddToCartButton();
    } else {
      console.log("Conditions not met for price calculation");
      if (priceDisplay) priceDisplay.style.display = "none";
    }
  }

  function validateDimensions(width, height) {
    const errors = {};
    const messages = {};

    if (width < 300) {
      errors.width = true;
      messages.width = "Min 300mm";
    } else if (width > 2200) {
      errors.width = true;
      messages.width = "Max 2200mm";
    }

    if (height < 200) {
      errors.height = true;
      messages.height = "Min 200mm";
    } else if (height > 2600) {
      errors.height = true;
      messages.height = "Max 2600mm";
    }

    if (width * height > 5750000) {
      errors.width = true;
      errors.height = true;
      messages.width = "Max 5,75 m²";
      messages.height = "Max 5,75 m²";
    }

    return { errors, messages };
  }

  function updateFieldValidation() {
    const width = parseInt(widthInput?.value) || 0;
    const height = parseInt(heightInput?.value) || 0;

    if (width > 0 && height > 0) {
      const validation = validateDimensions(width, height);

      // Käytä CSS-luokkia inline-tyylien sijaan
      const widthValidation = document.getElementById("width-validation");
      const heightValidation = document.getElementById("height-validation");

      if (validation.errors.width) {
        widthInput.style.borderColor = "#ff6b6b";
        if (widthValidation) {
          widthValidation.textContent = validation.messages.width;
          widthValidation.className = "validation-message error";
        }
      } else {
        widthInput.style.borderColor = "#333";
        if (widthValidation) {
          widthValidation.textContent = "";
          widthValidation.className = "validation-message";
        }
      }

      if (validation.errors.height) {
        heightInput.style.borderColor = "#ff6b6b";
        if (heightValidation) {
          heightValidation.textContent = validation.messages.height;
          heightValidation.className = "validation-message error";
        }
      } else {
        heightInput.style.borderColor = "#333";
        if (heightValidation) {
          heightValidation.textContent = "";
          heightValidation.className = "validation-message";
        }
      }

      if (validation.errors.width || validation.errors.height) {
        if (priceDisplay) priceDisplay.style.display = "none";
        return false;
      }
    }

    return true;
  }

  function createAddToCartButton() {
  // Tarkista onko nappi jo olemassa
  let existingButton = document.getElementById("premium-naru-add-to-cart");
  if (existingButton) {
    existingButton.style.display = "block";
    return;
  }

  // Luo uusi nappi
  const addToCartButton = document.createElement("button");
  addToCartButton.id = "premium-naru-add-to-cart";
  addToCartButton.type = "button";
  addToCartButton.textContent = "Lisää ostoskoriin";
  addToCartButton.className = "premium-add-to-cart-button";

  // UUSI: Cart API -pohjainen lisäys
  addToCartButton.addEventListener("click", function () {
    // Kerää tiedot
    const width = parseInt(widthInput.value);
    const height = parseInt(heightInput.value);
    const calculatedPriceValue = parseFloat(calculatedPrice.textContent.replace(' €', '').replace(',', '.'));
    const profileName = getProfilesForProduct()[selectedProfile].name;
    
    // Hae kangasväri
    const fabricSelect = document.querySelector('select[name="options[KANGAS]"]');
    const fabricOption = fabricSelect ? fabricSelect.options[fabricSelect.selectedIndex].text : 'Ei valittu';
    
    // Perustuotteen hinta
    const basePrice = 164.00;
    
    // Laske korotus
    const priceAdjustment = calculatedPriceValue - basePrice;
    
    // Luo unique ID tälle tuoteparille
    const pairId = Date.now().toString();
    
    // Valmistele Cart API -kutsu (käänteisessä järjestyksessä)
    const formData = {
      items: []
    };
    
    // Lisää räätälöinti AINA (jos hinta > 0)
    const adjustmentQuantity = Math.max(1, Math.round(priceAdjustment));
    
    formData.items.push({
      id: config.variantIds.adjustment,
      quantity: adjustmentQuantity,
      properties: {
        'Kangasväri': fabricOption,
        'Mitat': `${width}×${height} mm`,
        'Profiiliväri': profileName,
        '_pair_id': pairId,
        '_pair_order': '2'
      }
    });
    
    // Lisää perustuote TOISENA
    formData.items.push({
      id: config.variantIds.base,
      quantity: 1,
      properties: {
        '_pair_id': pairId,
        '_pair_order': '1'
      }
    });
    
    // Lähetä Cart API:lle
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(data => {
      console.log('Success:', data);
      // Päivitä ostoskori
      window.location.href = '/cart';
    })
    .catch((error) => {
      console.error('Error:', error);
      alert('Lisääminen ostoskoriin epäonnistui. Yritä uudelleen.');
    });
  });

  // Lisää hinta-osion jälkeen
  if (priceDisplay) {
    priceDisplay.appendChild(addToCartButton);
  }
  
  console.log("Add to cart button created");
}

  // Varmista hinnan päivitys kaikissa tilanteissa
  let lastValues = {
    width: "",
    height: "",
    fabric: "",
    profile: "",
  };

  function checkForChanges() {
    const currentWidth = widthInput?.value || "";
    const currentHeight = heightInput?.value || "";
    const currentFabric =
      document.querySelector('select[name="options[KANGAS]"]')?.value || "";
    const currentProfile = selectedProfile || "";

    if (
      currentWidth !== lastValues.width ||
      currentHeight !== lastValues.height ||
      currentFabric !== lastValues.fabric ||
      currentProfile !== lastValues.profile
    ) {
      console.log("Change detected, updating price...");

      // Päivitä kangasryhmä jos tarpeen
      if (currentFabric !== lastValues.fabric) {
        const fabricSelect = document.querySelector(
          'select[name="options[KANGAS]"]'
        );
        if (fabricSelect) {
          const selectedOption =
            fabricSelect.options[fabricSelect.selectedIndex];
          const variantTitle = selectedOption.text;
          const groupMatch = variantTitle.match(/\(([^)]+)\)[^(]*$/);
          if (groupMatch) {
            selectedFabricGroup = groupMatch[1];
            console.log("Updated fabric group:", selectedFabricGroup);
          }
        }
      }

      calculatePrice();

      lastValues.width = currentWidth;
      lastValues.height = currentHeight;
      lastValues.fabric = currentFabric;
      lastValues.profile = currentProfile;
    }
  }

  function updateAreaDisplay(width, height) {
    console.log("updateAreaDisplay called with:", width, height);

    const areaValueElement = document.getElementById("area-value");
    const areaDisplayElement = document.getElementById("area-display");

    console.log("Area value element:", areaValueElement);
    console.log("Area display element:", areaDisplayElement);

    if (!areaValueElement) {
      console.log("ERROR: area-value element not found!");
      return;
    }

    if (width > 0 && height > 0) {
      const area = ((width * height) / 1000000).toFixed(2);
      console.log("Calculated area:", area);

      areaValueElement.textContent = area + " m²";
      console.log("Area text updated to:", areaValueElement.textContent);

      // Muuta väri jos ylittää 5,75 m²
      if (parseFloat(area) > 5.75) {
        areaValueElement.style.color = "red";
        console.log("Area color set to red");
      } else {
        areaValueElement.style.color = "#dfa408";
        console.log("Area color set to green");
      }
    } else {
      areaValueElement.textContent = "- m²";
      areaValueElement.style.color = "white";
      console.log("Area reset to default");
    }
  }

  // Tarkista muutokset 500ms välein
  setInterval(checkForChanges, 500);
});
